export default __webpack_public_path__ + "static/media/categoria_coi.c6b272df.svg";